import API from '../utils/API';
import { makeActionCreator, makeGenericActionCreator } from '../utils/reduxUtils';
import { PAGINATION_PAGE_SIZE, BILLSBY_AUTH_DATA_CONTROL, BILLSBY_SELECTED_COMPANY } from '../utils/constants';
import { AppState } from '..';
import { IUser } from '../models/Users';
import { storeSetCrossDomain, storeRemoveCrossDomain } from '../utils/storeUtils';
import { ConfigConstants } from '../utils/config';
import { refreshToken } from '../utils/authUtils';
export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const UPDATE_USER_2FA_REQUEST = 'UPDATE_USER_2FA_REQUEST';
export const UPDATE_USER_2FA_SUCCESS = 'UPDATE_USER_2FA_SUCCESS';
export const UPDATE_USER_2FA_FAILURE = 'UPDATE_USER_2FA_FAILURE';

export const SET_USERS_FIELD = 'SET_USERS_FIELD';
type AllowedUsersReducerFields = 'searchedUsers';
export const setUsersField = makeGenericActionCreator<AllowedUsersReducerFields>(SET_USERS_FIELD);


export const RESET_USERS = 'RESET_USERS';
export const resetUsers = makeActionCreator(RESET_USERS, 'payload');


export const fetchUsers = function (pageNumber: number, pageSize: number = PAGINATION_PAGE_SIZE, search: string = '', includeAll: boolean = true) {
  return {
    types: [FETCH_USERS_REQUEST, FETCH_USERS_SUCCESS, FETCH_USERS_FAILURE],
    callAPI: () => API.fetchUsers(pageNumber, pageSize, search, includeAll)
  };
};

export const updatehUser2fa = function (userId: number) {
  return {
    types: [UPDATE_USER_2FA_REQUEST, UPDATE_USER_2FA_SUCCESS, UPDATE_USER_2FA_FAILURE],
    callAPI: () => API.updatehUser2fa(userId)
  };
};

export const fetchUserToken = function (user: IUser, isForceAccess: boolean) {
  return async (dispatch: Function, getState: () => AppState) => {
    try {
      const impersonatedUserToken = await API.fetchUserToken(user.userId, isForceAccess);
      storeSetCrossDomain(BILLSBY_AUTH_DATA_CONTROL, JSON.stringify(impersonatedUserToken));
      // remove any previous company cookie that was set
      storeRemoveCrossDomain(BILLSBY_SELECTED_COMPANY);
      if(user.companyRoles.length === 1) {
        storeSetCrossDomain(BILLSBY_SELECTED_COMPANY, user.companyRoles[0].companyId);
        // get correct company permissions
        await refreshToken(BILLSBY_AUTH_DATA_CONTROL, user.companyRoles[0].companyId);
        window.open(`//${user.companyRoles[0].companyDomain}${ConfigConstants.billsbyDomain}`, '_blank');
      } else {
        window.open(`//app${ConfigConstants.billsbyDomain}`, '_blank');
      }
    }
    catch(err) {}
  }
}